/* eslint-disable global-require, no-multi-assign, no-unused-vars */
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import Vue from 'vue';
import './plugins/axios/axios';
import './plugins/veevalidate/veevalidate';
import './plugins/sweetalert2/sweetalert2';
import './plugins/i18n/i18n';
/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

window.Vue = Vue;
window.Popper = require('popper.js').default;
window.$ = window.jQuery = require('jquery');
require('jquery.easing');
require('bootstrap');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('product-media-list', require('./components/ProductMediaList.vue').default);
Vue.component('product-category-list', require('./components/ProductCategoryList.vue').default);
Vue.component('product-category', require('./components/ProductCategory.vue').default);
Vue.component('product-box', require('./components/ProductBox.vue').default);
Vue.component('redeem-checkout', require('./components/RedeemCheckout.vue').default);
Vue.component('delivery-info-form', require('./components/DeliveryInfoForm.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#vueapp',
});

// scroll up button

$('.scrollup').hide();
$(window).on('scroll', () => {
    if ($(this).scrollTop() > 400) {
        $('.scrollup').fadeIn();
    } else {
        $('.scrollup').fadeOut();
    }
});

$('a.scrolltop[href^=\'#\']').on('click', (e) => {
    e.preventDefault();
    const { hash } = this;
    $('html, body').stop().animate({ scrollTop: 0 }, 1000, 'easeOutExpo');
});
